import { observable } from 'mobx'

class MetricsStore {
    constructor(store) {
        this.store = store
    }

    @observable metrics = []

    @observable language = { value: 'en_GB', label: 'English (UK)' }

    updateLanguage = (language) => {
        this.language = language
    }

    fetchMetrics = async () => {
        try {
            const response = await this.store.http.get('/metric')

            this.metrics = response.map((metric) => ({
                ...metric,
                value: JSON.parse(metric.value),
            }))
        } catch (e) {
            this.handleRequestError(e)
        }
    }

    handleInput = (e, index) => {
        this.metrics[index].value[this.language.value] = e.value

        this.metrics = [...this.metrics]
    }

    handleAddMetric = async () => {
        try {
            const response = await this.store.http.post('/intranet/metric', JSON.stringify({ value: JSON.stringify({ en_GB: '' }) }))

            this.metrics.push({
                ...response,
                value: JSON.parse(response.value),
            })
        } catch (e) {
            this.handleRequestError(e)
        }
    }

    handleDeleteMetric = async (index) => {
        const removedMetric = this.metrics[index]

        try {
            await this.store.http.delete(`/intranet/metric/${removedMetric.id}`)
            this.metrics = this.metrics.filter((m, i) => i !== index)
        } catch (e) {
            this.handleRequestError(e)
        }
    }

    handleSubmit = async () => {
        try {
            await Promise.all(this.metrics.map((metric) => this.store.http.put(`/intranet/metric/${metric.id}`, JSON.stringify({ value: JSON.stringify(metric.value) }))))
            this.handleUpdateSuccess()
        } catch (e) {
            this.handleRequestError(e)
        }
    }

    handleRequestError = (e) => {
        this.store.handleError({ body: `Something went wrong: ${e.message}`, level: 'error' })
    }

    handleUpdateSuccess = () => {
        this.store.addNotification({ body: `${this.metrics.length} metrics updated successfully`, level: 'success' })
    }
}

export default MetricsStore
